module.exports = __webpack_public_path__ + "static/media/circly_arm_price.6b558041.svg";